import PagelyStack from "../../../../src/images/services/pagely-stack.svg";
import * as React from 'react';
export default {
  PagelyStack,
  React
};